<template>
  <AppAlert :variant="variant">
    <template v-if="data.state === 'unpaid'">
      Your subscription has expired. Please use the page to reactivate it.
    </template>
    <template v-else-if="data.state === 'cancelled'">
      You canceled your subscription and it will end on <strong>{{ data.subscriptionEnd }}</strong>.
    </template>
    <template v-else>
      You do not have an active subscription. Please choose subscription plan and subscribe via Stripe/CreditCard or PayPal.
    </template>
  </AppAlert>
</template>

<script setup>
import { computed } from 'vue'
import { AppAlert } from '@/components/ui'

const props = defineProps({
  data: { type: Object, required: true }
})

const variant = computed(() => (props.data.state === 'cancelled' ? 'info' : 'danger'))
</script>
